import cities from "../data/cities";

export function getCoords(cityName) {
  if (!cityName) {
    console.error("getCoords called with undefined cityName");
    return { lat: 0, lng: 0 };
  }

  const match = cities.find(
    (c) => c.name.toLowerCase() === cityName.toLowerCase()
  );

  if (!match) {
    console.error("Missing coords for:", cityName);
    return { lat: 0, lng: 0 };
  }

  return {
    lat: match.lat,
    lng: match.lng
  };
}